<template>
  <div id="app" :class="themeCssClass">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "App",

  computed: {
    themeCssClass() {
      return this.$store.state.themeCssClass
    }
  },
};
</script>

<style lang="scss"></style>
